import { storageKey } from '@/constant/storage'
import { removeAuthToken } from '@/lib/auth/jwt'
import { trackLoginDebug } from '@/utils/loginDebug'
import { userState } from 'Store/user'
import { getRecoil, setRecoil } from 'recoil-nexus'

export async function signOut() {
  const user = getRecoil(userState)
  trackLoginDebug('sign_out', {
    hadUser: !!user?.user_id,
    stack: new Error().stack?.split('\n').slice(1, 6).join(' | '),
  })

  // Keep local cleanup synchronous so 401 handling preserves its original order.
  setRecoil(userState, null)
  removeAuthToken()
  localStorage.removeItem(storageKey.USER)

  try {
    const { auth } = await import('./firebase')
    return await auth.signOut()
  } catch (error) {
    console.error('Error signing out:', error)
  }
}
